export default {
  namespaced: true,
  state: () => ({
    formtype: "emailform",
    user: {
      session: null,
    },
  }),
  mutations: {
    SET_LOGIN_SESSION(state, session) {
      state.user.session = session;
    },
    SET_LOGIN_FORMTYPE(state, formtype) {
      state.formtype = formtype;
    },
  },
  actions: {
    setForm({ commit }, formtype) {
      commit("SET_LOGIN_FORMTYPE", formtype);
    },
    setSession({ commit }, session) {
      commit("SET_LOGIN_SESSION", session);
    },
    async loginUser({ commit }, { email, password }) {
      const body = new URLSearchParams({
        email,
        password,
      });

      const response = await fetch("http://localhost:90/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          backend: "login",
        },
        body: body.toString(),
      });

      const text_response = await response.text();
      const json_repsonse = JSON.parse(text_response);

      document.cookie = `backend=${json_repsonse.session}`;

      commit("SET_LOGIN_SESSION", json_repsonse.session);
    },
  },
};
